import firebase from "firebase";
import {SuggestedAvailability} from "./types";
import {OrderAddress} from "../../features/orders/redux/types";

export interface GetSuggestedAvailabilitiesInput {
    servicesIds: string[];
    timeRange: {
        from: number;
        to: number;
    },
    addressCoordinates: {
        lat: number;
        long: number;
    }
}

export interface BookSuggestedAvailabilityData {
    workerId: string;
    servicesIds: string[];
    serviceAddress: OrderAddress;
    invoiceAddress?: OrderAddress;
    email: string;
    estimatedFrom: number;
    estimatedTo: number;
    extraInfo?: string;
}

export class SuggestedAvailabilitiesService {
    async getSuggestedAvailabilities(data: GetSuggestedAvailabilitiesInput): Promise<SuggestedAvailability[]> {
        const result = await firebase.app()
            .functions('europe-west3')
            .httpsCallable('getAvailableAppointments')(data);

        return result.data as SuggestedAvailability[]
    }

    async bookSuggestedAvailability(data: BookSuggestedAvailabilityData): Promise<{status: 200 | 500, message?: string}> {
        const result = await firebase.app()
            .functions('europe-west3')
            .httpsCallable('bookSuggestedAvailability')(data);

        return result.data;
    }

    async confirmOrder(data: { orderId: string }) {
        const result = await firebase.app()
            .functions('europe-west3')
            .httpsCallable('confirmOrder')(data);

        return result.data;
    }
}